module.exports = __webpack_public_path__ + "img/组 1146.53b04a31.png";